<template>
  <div v-if="userProfile">
    <vs-popup background-color-popup="#fff" class="agreementPopup" :active.sync="popupShow">
      <div style="position: relative">
        <div style="max-height: 500px; overflow: auto" @scroll="onScroll" id="legalDocument" v-html="documentHtml"></div>
        <div class="popup-scroll-fade" :style="{ 'background-color': '#fff' }" v-if="!scrolledToBottom"></div>
        <div class="popup-scroll-fade-btn" v-if="!scrolledToBottom">
          <button @click="autoScroll()" class="">
            <img src="@/assets/images/arrow_down_btn.png" />
          </button>
        </div>
      </div>
      <button @click="popupShow = false" style="" class="btn-popup-close">
        <img src="@/assets/images/cancel_btn.png" />
      </button>

      <div class="flex justify-center mt-10">
        <p
          style="  text-gray-700
            font-medium
            text-sm
            hover:bg-blue-200
            "
        >
          Accepted {{ documentDate }}
        </p>
      </div>
    </vs-popup>

    <vx-card class="mt-6" no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-3/5 w-full">
          <h4 class="mb-4">Agreements</h4>
          <p>These are the documents that the guest has given consent to. Permissions are given based on these documents.</p>
          <vs-row class="mt-2" v-for="(d, idx) in userProfile.consentedDocuments" :key="idx">
            <vs-button
              class="w-64"
              @click="reviewDocument(d.venueId, d.legalDocumentId, d.revision, d.timestamp)"
              type="relief"
              icon="description"
            >
              <div>{{ d.publicName }}</div>
              <div class="text-sm font-semibold">{{ d.timestamp | formatDate }}</div>
            </vs-button>
          </vs-row>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {},
  props: {
    userProfile: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // eslint-disable-next-line
      _,

      scrolledToBottom: false,
      moment,
      popupShow: false,
      documentHtml: "",
      documentDate: "",

      apiConfig: {
        legalDocumentUrl: (venueid, docid, revision) =>
          `https://rekom-crm-functions-prod.azurewebsites.net/api/DynamicFormsGetLegalDocument?venueid=${venueid}&docid=${docid}&revision=${revision}`
      }
    };
  },
  computed: {
    ...mapGetters({
      venues: "venues/venues"
    })
  },
  methods: {
    autoScroll() {
      const objDiv = document.getElementById("legalDocument");
      objDiv.scrollTop = objDiv.scrollHeight;
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.scrolledToBottom = true;
      } else {
        //this.scrolledToBottom = false;
      }
    },

    async reviewDocument(venueId, id, revision, acceptDate) {
      this.$vs.loading();
      const url = this.apiConfig.legalDocumentUrl(venueId, id, revision);
      const result = await fetch(url);
      const json = await result.json();
      this.documentHtml = json.doc.documentHtml;
      this.documentDate = moment(acceptDate).format("DD/MM/YYYY HH:mm");
      this.$vs.loading.close();
      this.popupShow = true;
    }
  }
};
</script>

<style lang="scss">
.agreementPopup {
  .vs-popup--header {
    display: none;
  }
  .agreementPopup .vs-popup--header {
    display: none;
  }

  .con-vs-popup .vs-popup {
    max-width: 36rem;
    max-height: 50rem;
  }

  .vs-popup--header {
    display: none;
  }

  .vs-popup--content {
    padding-top: 3.5rem !important;
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .htmlDiv {
    overflow: auto;
  }

  .bg-black-opacity {
    background-color: rgba(0, 0, 0, 0.55);
  }
  ::-webkit-scrollbar {
    width: 0; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }
  /* Optional: show position indicator in red */
  ::-webkit-scrollbar-thumb {
    background: #ff0000;
  }
  .btn-popup-close {
    top: 1.5rem;
    right: 1.5rem;
    position: absolute;
    background-color: transparent;
    border: none;
  }
  .btn-popup-close img {
    object-fit: cover;
    height: 30px;
    width: auto;
  }

  .popup-scroll-fade {
    width: 100%;
    height: 80px;
    bottom: 0;
    left: 0;
    overflow: hidden;
    position: absolute;

    -webkit-mask-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 1)), to(rgba(0, 0, 0, 0)));
  }
  .popup-scroll-fade-btn {
    width: 50px;
    height: 50px;
    bottom: 0;
    margin-left: -25px;
    left: 50%;
    position: absolute;
  }
  .popup-scroll-fade-btn img {
    width: 50px;
    height: 50px;
    background-color: transparent;
  }
  .popup-scroll-fade-btn button {
    background-color: transparent;
    border: none;
  }

  .btn-cot:disabled {
    --tw-bg-opacity: 1;
    background-color: rgba(100, 106, 124, var(--tw-bg-opacity));
  }

  .btn-cot {
    border: none;
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, var(--tw-text-opacity));
    font-size: 0.875rem;
    line-height: 1.25rem;
    --tw-bg-opacity: 1;
    background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
    border-radius: 9999px;
    padding-top: 1.625rem;
    padding-bottom: 1.625rem;
    padding-left: 4rem;
    padding-right: 4rem;
    font-size: 1.125rem;
  }

  .text-sm {
    font-size: 0.875rem !important;
  }

  .font-medium {
    font-weight: 500 !important;
  }
}
</style>